module.exports = "/_next/static/images/HeroHome-57ac29157dbe44121907f4c3e50317c0.jpg";